import { UserIconType } from 'src/utils/constants/User';

export interface ITab {
  id: number;
  name: string;
  userIcon: UserIconType;
  subTypes?: string[];
}

/**
 * Determines the visibility of a element within its parent container.
 * Returns an object with properties indicating full visibility, partial visibility from left and right side
 */
export const getElementVisibilityWithinContainer = (container: HTMLDivElement, element: HTMLDivElement) => {
  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  const containerLeft = Math.floor(containerRect.left);
  const containerRight = Math.floor(containerRect.right);
  const elementLeft = Math.floor(elementRect.left);
  const elementRight = Math.floor(elementRect.right);

  return {
    fullyVisible: elementLeft >= containerLeft && elementRight <= containerRight,
    partiallyVisibleFromLeft: elementLeft < containerLeft && elementRight > containerLeft,
    partiallyVisibleFromRight: elementRight > containerRight && elementLeft < containerRight,
  };
};

export const getCaseIdFromURL = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('caseId');
};
